import React, { useState } from 'react'
import clsx from 'clsx'
import type { Step } from '../../types/session.types'
import { StepItem } from './StepItem'
import { StepDetailModal } from './StepDetailModal'
import styles from './StepList.module.css'

export interface StepListProps {
  sessionId: string
  teamId: string
  steps: Step[]
  className?: string
}

export function StepList({ sessionId, steps, className }: StepListProps) {
  const [selectedStep, setSelectedStep] = useState<Step | null>(null)

  return (
    <div className={clsx(styles.list, className)}>
      <h2 className={styles.heading}>My Steps ({steps.length})</h2>

      {steps.length === 0 ? (
        <div className={styles.empty}>No steps assigned to this team</div>
      ) : (
        steps.map((step, index) => (
          <StepItem
            key={step.id}
            step={step}
            index={index + 1}
            sessionId={sessionId}
            onClick={() => setSelectedStep(step)}
          />
        ))
      )}

      {selectedStep && (
        <StepDetailModal
          step={selectedStep}
          sessionId={sessionId}
          onClose={() => setSelectedStep(null)}
        />
      )}
    </div>
  )
}
